module.exports = __webpack_public_path__ + "img/gsndc2782_2.ff2cef14.svg";